<template>
  <div class="location">
    <div class="control-width mx-auto">
      <div class="p-4 p-md-5 border shadow-sm add-rounded">
        <h4 class="mb-3 font-weight-bold kova-text">Company Bio</h4>
        <br />
        <h6 class="mb-3 font-weight-bold text-left mt-4">Company name</h6>

        <a-input size="large" placeholder="Kovatek" v-model="company_name" class="mx-auto mb-3" />
        <br />

        <h6 class="mb-3 font-weight-bold text-left mt-4">Company Logo</h6>
        <div style="display:block">
          <a-upload
            name="file"
            :multiple="false"
            action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
            list-type="picture"
            :headers="headers"
            @change="handleUpload"
            class="text-left mt-4"
            style="display:block"
          >
            <a-button class="text-left" style="display:block">
              <a-icon type="upload" />Click to Upload
            </a-button>
          </a-upload>
        </div>

        <br />

        <h6 class="mb-3 font-weight-bold text-left mt-4">Country</h6>
        <a-select
          class="w-100 mb-3"
          size="large"
          placeholder="Please select your Country"
          v-model="country"
        >
          <a-select-option
            :value="item.name"
            v-for="(item, index) in countries"
            :key="index"
          >{{ item.name }}</a-select-option>
        </a-select>
        <br />

        <h6 class="mb-3 font-weight-bold text-left mt-4">City</h6>
        <a-select
          class="w-100 mb-3"
          size="large"
          placeholder="Please select your City"
          v-model="state"
        >
          <a-select-option
            :value="item.name.replace(/ State/g, '')"
            v-for="(item, index) in states"
            :key="index"
          >{{ item.name.replace(/ State/g, "") }}</a-select-option>
        </a-select>
        <br />
        <div class="container-fluid px-0 px-md-4 mb-5 mt-5">
          <div class="row">
            <div class="col text-left">
              <button
                class="btn-outline-kovatek py-2 px-4 px-sm-5 btn-rounded"
                v-on:click="goBack"
              >Back</button>
            </div>
            <div class="col text-right">
              <button class="btn-kovatek py-2 px-4 px-sm-5 btn-rounded" v-on:click="next">Next</button>
            </div>
          </div>
        </div>
      </div>
      <div class="text-right kova-text pt-3 mr-4 mb-5">
        <span @click="skip">
          Skip
          <font-awesome-icon icon="step-forward"></font-awesome-icon>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import countries from "@/plugins/countries.json";
export default {
  name: "company-bio",
  data() {
    return {
      info: null,
      countries,
      avatar: null,
      company_name: this.$store.state.fcjob.fcjobData.company_name,
      country: this.$store.state.fcjob.fcjobData.country,
      state: this.$store.state.fcjob.fcjobData.state,
      headers: {
        authorization: "authorization-text"
      }
    };
  },
  computed: {
    states() {
      const countr = this.countries.find(key => key.name === this.country);
      return countr ? countr.states : [];
    }
  },
  methods: {
    handleUpload({ file }) {
      if (file.status !== "uploading") {
        this.avatar = file.originFileObj;
      }
      if (file.status === "done") {
        this.$message.success(`${file.name} file uploaded successfully`);
      } else if (file.status === "error") {
        this.$message.error(`${file.name} file upload failed.`);
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    next() {
      const { company_name, country, state, avatar } = this;
      this.$store.commit("fcjob/updateFcJob", {
        company_name,
        country,
        state,
        avatar
      });
      this.$router.push("job-bio");
    },
    skip() {
      this.$router.push("job-bio");
    }
  },
  mounted() {}
};
</script>
<style scoped>
.ant-upload.ant-upload-select {
  display: block !important;
}

.control-width {
  width: 600px;
}

@media (min-width: 768px) and (max-width: 991px) {
}
@media (max-width: 767px) {
  .control-width {
    width: 500px;
  }
}
@media (max-width: 550px) {
  .control-width {
    width: 98%;
  }
}
</style>
